/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

import "../../css/style.css";

//비밀번호 찾기
const LeaveMember = ({varOpenLeave,onOpenLeaveHandler,onLeaveMemberHandler}) => {

  return (
    <div className="layer__pop open" style={varOpenLeave?{display:""}:{display:"none"}}>
      <div className="layer__pop__confirm">
        <div className="layer__pop__head">
          <div className="layer__pop__title">정말 탈퇴하시겠습니까?</div>
          <div className="layer__pop__close" onClick={e=>onOpenLeaveHandler(e,false)}></div>
        </div>
        <div className="layer__pop__body">
          <div className="layer__pop__text">
            탈퇴 후 이용 중인 정보가 모두 삭제되며<br/>
            동일한 아이디로 가입할 수 없습니다.<br/>
            정말 탈퇴하시겠습니까?
          </div>
        </div>
        <div className="layer__pop__bottom">
          <div className="layer__pop__btn white" onClick={e=>onLeaveMemberHandler(e)}>탈퇴</div>
          <div className="layer__pop__btn" onClick={e=>onOpenLeaveHandler(e,false)}>취소</div>
        </div>
      </div>
    </div>
  );
}
export default LeaveMember;